import { Box, Text, Image, Link } from "@chakra-ui/react";
import googledigital from "../../src/images/googledigital.png";
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from "react";

function Project2() {
  
  useEffect(()=>{
    Aos.init({duration: 2000});
   },[])

  return (
    <Box
    className="project-card"
    data-aos="flip-right"
      margin={"auto"}
      mb="80px"
      w="80%"
      justifyContent="center"
      alignContent={"center"}
      // className="project"
    >
      <Box  className="project-title" textAlign="center">
        <Text
          color={"#FFB6C1"}
          fontSize={{ base: "21px", md: "27px", lg: "38px" }}
          pt={30}
        >
          Google Digital Garage - Clone
        </Text>
      </Box>
      <Box
        alignItems={"center"}
        justifyContent={"center"}
        display={{ lg: "flex" }}
        textAlign="center"
      >
        <Image
          ml={{ lg: "30px" }}
          pt={10}
          m="auto"
          w={{ base: "80%", md: "70%", lg: "47%" }}
          src={googledigital}
        ></Image>
        <Box mt={50}>
          <Text
            color={"#FFB6C1"}
            fontSize={{ base: "18px", md: "23px", lg: "32px" }}
          >
            Description
          </Text>
          <Text
          className="project-description"
            margin="auto"
            mb={10}
            w="80%"
            fontSize={{ base: "12px", md: "16px", lg: "20px" }}
            mt={5}
          >
            Google Digital Garage was created by Google in 2015 as a nonprofit.
            programme designed to help people improve their digital skills. It
            provides free online training, courses, and certifications via an
            online learning platform.
          </Text>
          <Box>
            <Text
              color={"#FFB6C1"}
              fontSize={{ base: "18px", md: "23px", lg: "32px" }}
              mb={10}
            >
              Tech Stacks
            </Text>
            <Box
              fontSize={{ base: "12px", md: "16px", lg: "20px" }}
              justifyContent={"space-evenly"}
              display={"flex"}
              gap="1"
              className="project-tech-stack"
            >
              <Text>HTML</Text>
              <Text>CSS</Text>
              <Text>JavaScript</Text>
            </Box>
          </Box>
          <Box mt={"60px"} display={"flex"} justifyContent="space-around">
            <Link
            className="project-github-link"
              target="_blank"
              href="https://github.com/imrangadwal10/zonked-instrument-5361"
            >
              <Image
                w={{ base: "22px", md: "30px", lg: "40px" }}
                src="https://img.icons8.com/3d-fluency/2x/github.png"
              ></Image>
            </Link>
            <Link
            className="project-deployed-link"
              target="_blank"
              href="https://zonked-instrument-5361.vercel.app/"
            >
              <Image
                w={{ base: "20px", md: "26px", lg: "30px" }}
                src="https://cdn.iconscout.com/icon/free/png-64/netlify-3628945-3030170.png"
              ></Image>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Project2;
